import React from 'react'

let memoizedColumns=[];
const MitemColumns = () => {
    if (memoizedColumns.length > 0) {
        return memoizedColumns
    }
    memoizedColumns = [
        {
            accessorKey: 'checkbox',
            header: '',
        },
       
        {
            accessorKey: 'mitem',
            header: 'Mitem',
        },
        {
            accessorKey: 'section',
            header: 'Section',
        },
        {
            accessorKey: 'enable',
            header: 'Enable',
        },
       
    ]
    return memoizedColumns
}

export default MitemColumns